module.exports = __webpack_public_path__ + "img/julio-guzman.c3f92eec.png";